export default __webpack_public_path__ + "static/media/Detail-Sistem-Setoran.f78ff9ac.png";